import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import modules from './modules'
import createLogger from 'vuex/dist/logger'
const debug = process.env.NODE_ENV !== 'production'
Vue.use(Vuex)
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules,
  strict: debug, // 当debug=true时开启严格模式(性能有损耗)
  plugins: debug ? [createLogger()] : []
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js